import React, { Fragment, FunctionComponent, useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { StepperContent, StepperHeader, StepperSubmit } from '../../../../../shared/general';
import {
  utilsCalculatorCalculateBuyerCostsGetDefaultValuesStep2,
  utilsCalculatorCalculateBuyerCosts
} from '../../utils/';

import { FormElementDynamicInputTyped } from '../../../../../shared/form-elements';
import {
  CalculatorBuyerCostsFormFields,
  CalculatorBuyerCostsResultData,
  CalculatorsBuyerCostsStep2FormFields
} from '../../types';
import { useFormContext } from '../../../../../../hooks';
import { NhgContext } from '../../calculator-buyer-costs';
import { useIntl } from 'react-intl';
import { useCalculatorBuyerCostsStep2FormFields } from '../../config';

export const CalculatorBuyerCostsStepperStep2: FunctionComponent<{
  id: number;
  title?: string;
}> = ({ id, title }) => {
  const intl = useIntl();
  const calculatorBuyerCostsStep2FormFields = useCalculatorBuyerCostsStep2FormFields(intl);
  const [completedText, setCompletedText] = useState('');
  const nhg = useContext(NhgContext);
  const { updateForm, updateResult, setError, form } = useFormContext<
    CalculatorBuyerCostsResultData,
    CalculatorBuyerCostsFormFields
  >();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isValid }
  } = useForm({
    mode: 'onBlur',
    defaultValues: utilsCalculatorCalculateBuyerCostsGetDefaultValuesStep2(intl)
  });

  const onSubmit = async (formData: Record<keyof CalculatorsBuyerCostsStep2FormFields, string>) => {
    updateForm(formData);

    try {
      const result = utilsCalculatorCalculateBuyerCosts(
        { ...form, ...formData } as CalculatorBuyerCostsFormFields,
        nhg
      );
      updateResult(result);
      updateForm(formData);
      setCompletedText('');
    } catch (e) {
      setError(true);
      // Handle error
    }
  };

  return (
    <Fragment>
      <StepperHeader title={title} id={id} completedText={completedText} />
      <StepperContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormElementDynamicInputTyped<CalculatorsBuyerCostsStep2FormFields>
            formFields={calculatorBuyerCostsStep2FormFields}
            id={'applicantAgeUnder35'}
            register={register}
            errors={errors}
            values={watch()}
            options={{ required: true }}
          />

          <FormElementDynamicInputTyped<CalculatorsBuyerCostsStep2FormFields>
            formFields={calculatorBuyerCostsStep2FormFields}
            id={'applicantTransferTaxExemptionUsed'}
            register={register}
            errors={errors}
            values={watch()}
            options={{ required: true }}
          />

          {form.withPartner === 'true' && (
            <>
              <FormElementDynamicInputTyped<CalculatorsBuyerCostsStep2FormFields>
                formFields={calculatorBuyerCostsStep2FormFields}
                id={'partnerAgeUnder35'}
                register={register}
                errors={errors}
                values={watch()}
                options={{ required: true }}
              />
              <FormElementDynamicInputTyped<CalculatorsBuyerCostsStep2FormFields>
                formFields={calculatorBuyerCostsStep2FormFields}
                id={'partnerTransferTaxExemptionUsed'}
                register={register}
                errors={errors}
                values={watch()}
                options={{ required: true }}
              />
            </>
          )}

          <FormElementDynamicInputTyped<CalculatorsBuyerCostsStep2FormFields>
            formFields={calculatorBuyerCostsStep2FormFields}
            id={'willLiveInProperty'}
            register={register}
            errors={errors}
            values={watch()}
            options={{
              required: true,
              label: intl.formatMessage(
                {
                  id: 'step2.willLiveInProperty.label',
                  defaultMessage: '{salutation} zelf in de woning wonen?'
                },
                { salutation: form.withPartner === 'true' ? 'Gaan jullie' : 'Ga je' }
              )
            }}
          />

          <StepperSubmit id={id} isValidated={isValid} />
        </form>
      </StepperContent>
    </Fragment>
  );
};
